module.exports = "./assets/images/avatar-9.svg";